import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientColorMap } from "../layout/patientColorMap";

//region [[ Styles ]]

const ProfileSectionItemView = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

const ItemTitle = styled("div")(({ theme }) => ({
  marginBottom: "10px",
}));

const RemoveItem = styled("div")(({ theme }) => ({
  fontSize: "14px",
  textDecoration: "underline",
  color: PatientColorMap.Primary,
  cursor: "pointer",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ProfileSectionItemProps {
  item: string;
  onRemove: (item: string) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ProfileSectionItem = ({ ...props }: ProfileSectionItemProps) => {
  const onRemove = (event) => {
    props.onRemove(props.item);
  };

  return (
    <ProfileSectionItemView>
      <ItemTitle>{props.item}</ItemTitle>

      <RemoveItem onClick={onRemove}>Remove</RemoveItem>
    </ProfileSectionItemView>
  );
};
